/**
 * The RouteInstructions view allow to display a route instructions.
 *
 * The tomtom.routeInstructions() method creates a new instance of RouteInstructions control.
 *
 * @module Widgets
 * @class routeInstructions
 *
 */
define('widgets/controls/routeInstructions',['display/map', 'unitFormatConverter/unitFormatConverter'], function(L, unitFormatConverter) {
    'use strict';

    var EVENTS = {
            InstructionClickedSelect: 'instructionClickedSelect',
            InstructionClickedDeselect: 'instructionClickedDeselect',
            InstructionHoverOn: 'instructionHoverOn',
            InstructionHoverOff: 'instructionHoverOff',
            InstructionGroupClickedCollapse: 'instructionGroupClickedCollapse',
            InstructionGroupClickedExpand: 'instructionGroupClickedExpand',
            InstructionGroupHoverOn: 'instructionGroupHoverOn',
            InstructionGroupHoverOff: 'instructionGroupHoverOff'
        },

        CSS_CLASS_NAME = 'leaflet-control-route-instructions',

        MANOUVERS_WITH_LEFT_DRIVING_SIDE_VERSIONS = ['MAKE_UTURN', 'TRY_MAKE_UTURN', 'ROUNDABOUT_RIGHT',
            'ROUNDABOUT_LEFT', 'ROUNDABOUT_CROSS', 'ROUNDABOUT_BACK'],

        iconsMap = {
            'ARRIVE': 'icon-end-black',
            'ARRIVE_LEFT': 'icon-end-black',
            'ARRIVE_RIGHT': 'icon-end-black',
            'DEPART': 'icon-start-black',
            'STRAIGHT': 'icon-follow',
            'KEEP_RIGHT': 'icon-keep_right',
            'BEAR_RIGHT': 'icon-bear_right',
            'TURN_RIGHT': 'icon-turn_right',
            'SHARP_RIGHT': 'icon-sharp_right',
            'KEEP_LEFT': 'icon-keep_left',
            'BEAR_LEFT': 'icon-bear_left',
            'TURN_LEFT': 'icon-turn_left',
            'SHARP_LEFT': 'icon-sharp_left',
            'MAKE_UTURN': 'icon-make_uturn',
            'MAKE_UTURN_LEFT_DRIVING_SIDE': 'icon-make_uturn_left_driving_side',
            'ENTER_MOTORWAY': 'icon-freeway',
            'ENTER_FREEWAY': 'icon-freeway',
            'ENTER_HIGHWAY': 'icon-freeway',
            'TAKE_EXIT': 'icon-follow',
            'MOTORWAY_EXIT_LEFT': 'icon-keep_left',
            'MOTORWAY_EXIT_RIGHT': 'icon-keep_right',
            'TAKE_FERRY': 'icon-ferry',
            'ROUNDABOUT_CROSS': 'icon-roundabout_cross',
            'ROUNDABOUT_CROSS_45': 'icon-roundabout_cross_45',
            'ROUNDABOUT_RIGHT_135': 'icon-roundabout_right_135',
            'ROUNDABOUT_CROSS_MINUS_45': 'icon-roundabout_cross_minus_45',
            'ROUNDABOUT_LEFT_MINUS_135': 'icon-roundabout_left_minus_135',
            'ROUNDABOUT_RIGHT': 'icon-roundabout_right',
            'ROUNDABOUT_LEFT': 'icon-roundabout_left',
            'ROUNDABOUT_BACK': 'icon-roundabout_back',
            'TRY_MAKE_UTURN': 'make_uturn',
            'TRY_MAKE_UTURN_LEFT_DRIVING_SIDE': 'icon-make_uturn_left_driving_side',
            'ROUNDABOUT_CROSS_LEFT_DRIVING_SIDE': 'icon-roundabout_cross_left_driving_side',
            'ROUNDABOUT_CROSS_45_LEFT_DRIVING_SIDE': 'icon-roundabout_cross_45_left_driving_side',
            'ROUNDABOUT_RIGHT_135_LEFT_DRIVING_SIDE': 'icon-roundabout_right_135_left_driving_side',
            'ROUNDABOUT_CROSS_MINUS_45_LEFT_DRIVING_SIDE': 'icon-roundabout_cross_minus_45_left_driving_side',
            'ROUNDABOUT_LEFT_MINUS_135_LEFT_DRIVING_SIDE': 'icon-roundabout_left_minus_135_left_driving_side',
            'ROUNDABOUT_RIGHT_LEFT_DRIVING_SIDE': 'icon-roundabout_right_left_driving_side',
            'ROUNDABOUT_LEFT_LEFT_DRIVING_SIDE': 'icon-roundabout_left_left_driving_side',
            'ROUNDABOUT_BACK_LEFT_DRIVING_SIDE': 'icon-roundabout_back_left_driving_side',
            'FOLLOW': 'icon-follow',
            'WAYPOINT_LEFT': 'icon-flag-black',
            'WAYPOINT_RIGHT': 'icon-flag-black',
            'WAYPOINT_REACHED': 'icon-flag-black'
        };
    var RouteInstructions;

    function createDOMElements(control) {
        var container = L.DomUtil.create('div', CSS_CLASS_NAME + ' leaflet-control');
        control.container = container;
        container.style.width = control.options.size[0] + 'px';
        container.style.maxHeight = control.options.size[1] + 'px';

        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);

        container.style.visibility = 'hidden';

        return container;
    }

    function clearDOMElements(control) {
        control.container.innerHTML = '';
    }

    function updateDOMElements(control) {
        clearDOMElements(control);
        if (control.options.showInstructionGroups) {
            createInstructionsWithGroups(control, control.guidanceData);
        } else {
            createInstructions(control, control.container, control.guidanceData.instructions);
        }
    }

    function createInstructionsWithGroups(control, guidance) {
        var container = control.container;
        var allInstructionsPoints = [];
        var instructionIndex,
            groupIndex,
            instructionGroup,
            groupElementDiv,
            groupedInstructionsDiv,
            groupMessageWithIconDiv,
            collapseIconDiv,
            groupMessageDiv,
            separatorCssClassName,
            instructionListForGroup,
            groupedInstructionPoints;

        for (instructionIndex = 0; instructionIndex < guidance.instructions.length; instructionIndex += 1) {
            allInstructionsPoints.push(guidance.instructions[instructionIndex].point);
        }

        for (groupIndex = 0; groupIndex < guidance.instructionGroups.length; groupIndex += 1) {
            instructionGroup = guidance.instructionGroups[groupIndex];
            groupElementDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-group-element', container);
            groupedInstructionsDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-grouped-instructions', container);

            groupMessageWithIconDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-group-message-with-icon', groupElementDiv);
            collapseIconDiv = createCollapseIconDiv(control.options.instructionGroupsCollapsed);
            groupMessageDiv = createGroupMessageDiv(instructionGroup);
            groupMessageWithIconDiv.appendChild(collapseIconDiv);
            groupMessageWithIconDiv.appendChild(groupMessageDiv);

            separatorCssClassName = control.options.instructionGroupsCollapsed ? 'separator-end-group' : 'separator-between-instructions';
            createSeparatorDiv(groupElementDiv, instructionGroup.groupLengthInMeters, control.isImperialDistance, separatorCssClassName, true);

            instructionListForGroup = guidance.instructions.slice(instructionGroup.firstInstructionIndex,
                instructionGroup.lastInstructionIndex + 1);
            groupedInstructionPoints = createInstructions(control, groupedInstructionsDiv, instructionListForGroup,
                guidance.instructions[instructionGroup.lastInstructionIndex + 1]);

            registerHandlersForGroup({control: control,
                groupElementDiv: groupElementDiv,
                groupMessage: instructionGroup.groupMessage,
                groupedInstructionPoints: groupedInstructionPoints,
                collapseIconDiv: collapseIconDiv,
                groupedInstructionsDiv: groupedInstructionsDiv,
                allInstructionsPoints: allInstructionsPoints
            });

            if (control.options.instructionGroupsCollapsed) {
                groupedInstructionsDiv.style.display = 'none';
            }
        }
    }

    function createInstructions(control, divForInstructions, instructionList, instructionNextToGroup) {
        var nextInstructionOffset = 0;
        var instructionPoints = [];
        var instructionIndex,
            currentInstruction,
            nextInstruction,
            instructionElementDiv,
            separatorCssClassName;

        for (instructionIndex = 0; instructionIndex < instructionList.length; instructionIndex += 1) {
            currentInstruction = instructionList[instructionIndex];
            instructionPoints.push(currentInstruction.point);
            nextInstruction = instructionList[instructionIndex + 1];
            instructionElementDiv = createInstructionElement(currentInstruction);
            divForInstructions.appendChild(instructionElementDiv);
            separatorCssClassName = 'separator-between-instructions';

            if (nextInstruction !== undefined) {
                nextInstructionOffset = nextInstruction.routeOffsetInMeters;
            } else if (instructionNextToGroup) {
                nextInstructionOffset = instructionNextToGroup.routeOffsetInMeters;
                separatorCssClassName = 'separator-end-group';
            }

            createSeparatorDiv(instructionElementDiv, nextInstructionOffset - currentInstruction.routeOffsetInMeters,
                control.isImperialDistance, separatorCssClassName);
            registerHandlersForInstruction(control, instructionElementDiv, currentInstruction);
        }

        return instructionPoints;
    }

    function createCollapseIconDiv(isInstructionGroupsCollapsed) {
        var collapseIconClass = isInstructionGroupsCollapsed ? 'icon-expand' : 'icon-collapse';
        return L.DomUtil.create('div', CSS_CLASS_NAME + '-collapse-icon ' + collapseIconClass);
    }

    function createGroupMessageDiv(instructionGroup) {
        var groupMessageDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-group-message');
        groupMessageDiv.innerHTML = instructionGroup.groupMessage;
        return groupMessageDiv;
    }

    function createInstructionElement(instruction) {
        var messageDiv;
        var instructionElementDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-instruction-element');
        var messageWithIconDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-message-with-icon', instructionElementDiv);
        L.DomUtil.create('div', CSS_CLASS_NAME + '-icon ' + iconsMap[getIconPathKey(instruction)], messageWithIconDiv);
        messageDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-message', messageWithIconDiv);
        messageDiv.innerHTML = instruction.message;
        return instructionElementDiv;
    }

    function createSeparatorDiv(divToSeparate, instructionDistance, isImperialDistance, separatorCssClass, isInstructionGroup) {
        var separatorDistanceDiv,
            autoLengthSeparatorDiv,
            instructionSeparatorDiv,
            distanceDiv;
        if (instructionDistance === 0) {
            return;
        }
        separatorDistanceDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-separator-distance', divToSeparate);
        if (isInstructionGroup) {
            L.DomUtil.addClass(separatorDistanceDiv, CSS_CLASS_NAME + '-group-separator-distance');
        }
        autoLengthSeparatorDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-auto-length-separator', separatorDistanceDiv);
        instructionSeparatorDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-separator', autoLengthSeparatorDiv);
        L.DomUtil.addClass(instructionSeparatorDiv, separatorCssClass);
        distanceDiv = L.DomUtil.create('div', CSS_CLASS_NAME + '-distance', separatorDistanceDiv);
        distanceDiv.innerHTML = unitFormatConverter.formatDistance(instructionDistance, isImperialDistance);
    }

    function registerHandlersForGroup(params) {
        L.DomEvent.on(params.groupElementDiv, 'mouseenter', function() {
            params.control.fire(EVENTS.InstructionGroupHoverOn, createEventObject(params.groupedInstructionPoints, params.groupMessage));
        });
        L.DomEvent.on(params.groupElementDiv, 'mouseleave', function() {
            params.control.fire(EVENTS.InstructionGroupHoverOff);
        });
        L.DomEvent.on(params.groupElementDiv, 'click', function() {
            var separator;
            params.control.container.focus();
            separator = params.groupElementDiv.getElementsByClassName('leaflet-control-route-instructions-separator')[0];
            toggleCssClasses(separator, ['separator-between-instructions', 'separator-end-group']);
            toggleCssClasses(params.collapseIconDiv, ['icon-collapse', 'icon-expand']);

            if (params.groupedInstructionsDiv.style.display === 'none') {
                params.groupedInstructionsDiv.style.display = '';
                params.control.fire(EVENTS.InstructionGroupClickedExpand, createEventObject(params.groupedInstructionPoints));
            } else {
                params.groupedInstructionsDiv.style.display = 'none';
                params.control.fire(EVENTS.InstructionGroupClickedCollapse, createEventObject(params.allInstructionsPoints));
            }
        });
    }

    function toggleCssClasses(htmlElement, cssClassesArray) {
        cssClassesArray.forEach(function(className) {
            if (L.DomUtil.hasClass(htmlElement, className)) {
                L.DomUtil.removeClass(htmlElement, className);
            } else {
                L.DomUtil.addClass(htmlElement, className);
            }
        });
    }

    function createEventObject(instructionPoints, instructionMessage) {
        var eventObject = {};
        if (instructionPoints.constructor.toString().indexOf('Array') > -1) {
            eventObject.points = instructionPoints;
        } else {
            eventObject.point = instructionPoints;
        }
        if (instructionMessage) {
            eventObject.message = instructionMessage;
        }

        return eventObject;
    }

    function registerHandlersForInstruction(control, instructionElement, instruction) {
        L.DomEvent.on(instructionElement, 'mouseenter', function() {
            control.fire(EVENTS.InstructionHoverOn, createEventObject(instruction.point, instruction.message));
        });
        L.DomEvent.on(instructionElement, 'mouseleave', function() {
            control.fire(EVENTS.InstructionHoverOff);
        });
        L.DomEvent.on(instructionElement, 'click', function() {
            var selectedInstructionClass;
            control.container.focus();
            selectedInstructionClass = ['selected-instruction'];

            if (L.DomUtil.hasClass(instructionElement, selectedInstructionClass)) {
                control.fire(EVENTS.InstructionClickedDeselect);
            } else {
                deselectInstruction(control.container, selectedInstructionClass, control);
                control.fire(EVENTS.InstructionClickedSelect, createEventObject(instruction.point, instruction.message));
            }

            toggleCssClasses(instructionElement, selectedInstructionClass);
        });
    }

    function deselectInstruction(container, selectedInstructionClass, control) {
        var selectedInstruction = container.getElementsByClassName(selectedInstructionClass)[0];
        if (selectedInstruction) {
            L.DomUtil.removeClass(selectedInstruction, selectedInstructionClass);
            control.fire(EVENTS.InstructionClickedDeselect);
        }
    }

    function getIconPathKey(instruction) {
        var iconKey = instruction.maneuver;
        if (instruction.maneuver === 'ROUNDABOUT_CROSS') {
            if (instruction.turnAngleInDecimalDegrees >= 22 && instruction.turnAngleInDecimalDegrees <= 68) {
                iconKey += '_45';
            } else if (instruction.turnAngleInDecimalDegrees <= -22 && instruction.turnAngleInDecimalDegrees >= -68) {
                iconKey += '_MINUS_45';
            }
        }
        if (instruction.maneuver === 'ROUNDABOUT_RIGHT' && instruction.turnAngleInDecimalDegrees >= 122 && instruction.turnAngleInDecimalDegrees <= 158) {
            iconKey += '_135';
        }
        if (instruction.maneuver === 'ROUNDABOUT_LEFT' && instruction.turnAngleInDecimalDegrees >= -158 && instruction.turnAngleInDecimalDegrees <= -122) {
            iconKey += '_MINUS_135';
        }
        if (instruction.drivingSide === 'LEFT' && MANOUVERS_WITH_LEFT_DRIVING_SIDE_VERSIONS.indexOf(instruction.maneuver) !== -1) {
            iconKey += '_LEFT_DRIVING_SIDE';
        }
        return iconKey;
    }

    /**
     * The method to instantiates the control. The options can be passed on creation.
     *
     * @method routeInstructions
     * @param {Object} [options] Options to setup control.
     * @param {Object} [options.size=[320, 320]] Size of panel. The first parameter is width and the second is the
     *     maximum height. It will fit to the size of the instructions.
     * @param {String} [options.position="topleft"] Where to add view.
     * @param {Boolean} [options.instructionGroupsCollapsed=false] Should instruction groups be collapsed on init.
     * @param {Boolean} [options.showInstructionGroups=true] Should instruction groups be displayed.
     * @param {Boolean} [options.imperialDistance=false] Should the distance be displayed in imperial units.
     *
     * @example
     * ```javascript
     *
     * var options = {
     *     size: [270, 268],
     *     position: "topleft"
     * };
     * var routeInstructionsInstance = routeInstructions(options).addTo(map);
     * ```
     */
    RouteInstructions = L.Control.extend({

        includes: L.Mixin.Events,

        options: {
            size: [320, 320],
            position: 'topleft',
            instructionGroupsCollapsed: false,
            showInstructionGroups: true,
            imperialDistance: false
        },

        /**
         * Leaflet init method executed when adding control to map.
         * Options will be stored inside control.
         * @method initialize
         * @param {Object} [options] Options to setup control.
         */
        initialize: function(options) {
            L.Util.setOptions(this, options);
        },

        /**
         * Leaflet method executed when adding control to map.
         * Map will be stored inside control.
         * @method onAdd
         * @return {DOMElement} The main HTML element containing the widget.
         */
        onAdd: function() {
            return createDOMElements(this);
        },

        /**
         * Method to show route instructions.
         * By default instructions will be hidden.
         * Use this method to show control after data is ready.
         * @method show
         */
        show: function() {
            if (this.guidanceData) {
                this.container.style.visibility = '';
            }
        },

        /**
         * Method to hide route instructions.
         * By default instructions will be hidden.
         * @method hide
         */
        hide: function() {
            this.container.style.visibility = 'hidden';
        },

        /**
         * Method to update data after route is recalculated.
         * Use this method to update data after each route calculation.
         * @method updateGuidanceData
         * @param {Object} guidanceData The routing properties object containing instruction groups and instructions.
         * @param {Boolean} [imperial] Display distance in imperial units.
         */
        updateGuidanceData: function(guidanceData, imperial) {
            this.guidanceData = guidanceData;
            this.isImperialDistance = imperial || this.options.imperialDistance;
            updateDOMElements(this);
            this.show();
        },

        /**
         * Method to show instructions with groups if there are any.
         * @method showInstructionGroups
         */
        showInstructionGroups: function() {
            if (this.guidanceData && !this.options.showInstructionGroups) {
                this.options.showInstructionGroups = true;
                updateDOMElements(this);
            }
        },

        /**
         * Method to hide instructions groups. Use this method to disable groups. Only instructions will be visible.
         * @method hideInstructionGroups
         */
        hideInstructionGroups: function() {
            if (this.guidanceData && this.options.showInstructionGroups) {
                this.options.showInstructionGroups = false;
                updateDOMElements(this);
            }
        },

        /**
         * Event that is fired when instruction is clicked and is not selected. In this case clicked instruction will
         * be marked as selected (selected-instruction css class will be added). If any other instruction is selected,
         * it will be deselect.
         *
         * @event InstructionClickedSelect
         * @param {Object} point Object of point that represents latitude and longitude of instruction location.
         * @param {String} message Instruction message.
         * @param {String} type Event's name, equal to "instructionClickedDeselect".
         * @param {Element} target Event's target.
         *
         * @example
         * ```javascript
         *
         * var routeInstructionsInstance = tomtom.routeInstructions().addTo(map);
         * routeInstructionsInstance.on(routeInstructionsInstance.Event.InstructionClickedSelect,
         * function (eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        /**
         * Event that is fired when instruction is clicked and is selected. In this case clicked instruction will
         * be deselect (selected-instruction css class will be removed).
         *
         * @event InstructionClickedDeselect
         * @param {String} type Event's name, equal to "instructionClickedDeselect".
         * @param {Element} target Event's target.
         *
         * @example
         * ```javascript
         *
         * var routeInstructionsInstance = tomtom.routeInstructions().addTo(map);
         * routeInstructionsInstance.on(routeInstructionsInstance.Event.InstructionClickedDeselect,
         * function (eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        /**
         * Event that is fired when cursor is moving into instruction.
         *
         * @event InstructionHoverOn
         * @param {Object} point Object of point that represents latitude and longitude of instruction location.
         * @param {String} message Instruction message.
         * @param {String} type Event's name, equal to "instructionHoverOn".
         * @param {Element} target Event's target.
         *
         * @example
         * ```javascript
         *
         * var routeInstructionsInstance = tomtom.routeInstructions().addTo(map);
         * routeInstructionsInstance.on(routeInstructionsInstance.Event.InstructionHoverOn,
         * function (eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        /**
         * Event that is fired when cursor is moving out of instruction.
         *
         * @event InstructionHoverOff
         * @param {String} type Event's name, equal to "instructionHoverOff".
         * @param {Element} target Event's target.
         *
         * @example
         * ```javascript
         *
         * var routeInstructionsInstance = tomtom.routeInstructions().addTo(map);
         * routeInstructionsInstance.on(routeInstructionsInstance.Event.InstructionHoverOff,
         * function (eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        /**
         * Event that is fired when group of instructions is clicking and related instructions are collapsing.
         *
         * @event InstructionGroupClickedCollapse
         * @param {Object} points Object with points that represents latitude and longitude of all instruction locations in route.
         * @param {String} type Event's name, equal to "instructionGroupClickedCollapse".
         * @param {Element} target Event's target.
         *
         * @example
         * ```javascript
         *
         * var routeInstructionsInstance = tomtom.routeInstructions().addTo(map);
         * routeInstructionsInstance.on(routeInstructionsInstance.Event.InstructionGroupClickedCollapse,
         * function (eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        /**
         * Event that is fired when group of instructions is clicking and related instructions are expanding.
         *
         * @event InstructionGroupClickedExpand
         * @param {Object} points Object with points that represents latitude and longitude of all instruction locations in group.
         * @param {String} type Event's name, equal to "instructionGroupClickedExpand".
         * @param {Element} target Event's target.
         *
         * @example
         * ```javascript
         *
         * var routeInstructionsInstance = tomtom.routeInstructions().addTo(map);
         * routeInstructionsInstance.on(routeInstructionsInstance.Event.InstructionGroupClickedExpand,
         * function (eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        /**
         * Event that is fired when cursor is moving into group of instructions.
         *
         * @event InstructionGroupHoverOn
         * @param {Array} points Array of objects that contains points (latitude and longitude) of all instructions from this group.
         * @param {String} message Group message.
         * @param {String} type Event's name, equal to "instructionGroupHoverOn".
         * @param {Element} target Event's target.
         *
         * @example
         * ```javascript
         *
         * var routeInstructionsInstance = tomtom.routeInstructions().addTo(map);
         * routeInstructionsInstance.on(routeInstructionsInstance.Event.InstructionGroupHoverOn,
         * function (eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        /**
         * Event that is fired when cursor is moving out of group of instructions.
         *
         * @event InstructionGroupHoverOff
         * @param {String} type Event's name, equal to "instructionGroupHoverOff".
         * @param {Element} target Event's target.
         *
         * @example
         * ```javascript
         *
         * var routeInstructionsInstance = tomtom.routeInstructions().addTo(map);
         * routeInstructionsInstance.on(routeInstructionsInstance.Event.InstructionGroupHoverOff,
         * function (eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        Event: EVENTS
    });

    return function(options) {
        return new RouteInstructions(options);
    };
});

